import generateCreateDefaultState from './generateCreateDefaultState';
import createJobDefaultReducer from './createJobDefaultReducer';

export default (state = generateCreateDefaultState('DISPATCH'), action) => {
  return createJobDefaultReducer('DISPATCH', action, state);
};
